import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { Link, useHistory } from "react-router-dom";
import ReactPaginate from "react-paginate";
import _ from "lodash";
import "./Custom.css";
import "../loader.css";

function VoiceList(props) {
  const [VoiceList, setVoiceList] = useState([]);
  const [VoiceList2, setVoiceList2] = useState([]);
  const [, setCurrentPage] = useState(0);
  const [Record, seRecord] = useState([]);
  const [paginatedPosts, setPaginatedPosts] = useState();
  const navigate = useHistory();
  const [isLoading, setIsLoading] = useState(true);
  const [filterText, setFilterText] = useState("");
  const [isFocusOnFilterText, setIsFocusOnFilterText] = useState(false);

  let pageSize = 10;

  useEffect(() => {
    LoadVoice();
  }, [pageSize]);

  const LoadVoice = () => {
    axios.get(`${process.env.REACT_APP_API_URL}/GetAllVoice`).then((res) => {
      initVoiceList(res.data);
    });
  };

  const initVoiceList = (data) => {
    seRecord(data.length);
    if (data.length > 10) {
      setVoiceList(data);

      setPaginatedPosts(_(data).slice(0).take(pageSize).value());
    } else {
      setVoiceList2(data);
    }
    setIsLoading(false);
  }

  const onClearClicked = () => {
    setFilterText("");
    LoadVoice();
  };

  const FilterCases = () => {
    setIsLoading(true);
    if (filterText === "") {
      LoadVoice();
    } else {
      const dataValue = {
        searchString: filterText,
      };

      const authOptions = {
        method: "post",
        url: `${process.env.REACT_APP_API_URL}/GetVoiceByName`,
        data: dataValue,
        headers: { "Content-Type": "multipart/form-data" },
      };
      axios(authOptions).then((res) => {
        initVoiceList(res.data);
      });
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' && isFocusOnFilterText) {
      FilterCases();
    }
  };

  const handleFocus = () => {
    setIsFocusOnFilterText(true);
  };

  const handleBlur = () => {
    setIsFocusOnFilterText(false);
  };

  const pageCount = VoiceList ? Math.ceil(VoiceList.length / pageSize) : 0;
  if (pageCount === 1) return null;
  _.range(1, pageCount + 1);

  const handlePageClick = async (data) => {
    let currentPage = data.selected + 1;
    setCurrentPage(currentPage);
    const startIndex = (currentPage - 1) * pageSize;
    const paginatedPost = _(VoiceList)
      .slice(startIndex)
      .take(pageSize)
      .value();
    setPaginatedPosts(paginatedPost);
  };

  const EditVoice = (voiceId) => {
    localStorage.setItem("VoiceId", voiceId);
  };

  const deleteVoice = (value) => {
    const dataValue = {
      voiceId: value,
    };

    let token = null;
    try {
      const raw = localStorage.getItem("state");
      if (raw) {
        const state = JSON.parse(raw);
        token = state.auth?.token;
      }
    } catch (e) {
      console.error("Token parsing failed", e);
    }

    const authOptions = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/DeleteVoice`,
      data: dataValue,
      headers: { "Content-Type": "multipart/form-data", ...(token && { "Authorization": `Bearer ${token}` }) },
    };

    axios(authOptions)
      .then((res) => {
        if (res.data.ExpResult) {
          Swal.fire({
            title: "Failed",
            text: res.data.ExpResult,
            icon: "error",
            confirmButtonText: "Ok",
          }).then(() => { });
        } else if (res.data.SuccessResult) {
          Swal.fire({
            title: "Success",
            text: res.data.SuccessResult,
            icon: "success",
            confirmButtonText: "Ok",
          }).then(function () {
            window.location.reload();
          });
        } else {
          Swal.fire({
            title: "Error",
            text: "An error occurred!",
            icon: "error",
            confirmButtonText: "Ok",
          }).then(() => { });
        }
      })
      .catch((error) => {
        Swal.fire({
          title: "Failed",
          text: error,
          icon: "error",
          confirmButtonText: "Ok",
        }).then(() => { });
      });
  };

  const BackFunc = () => {
    navigate.push("/index");
  };

  return (
    <>
      <div className="page-content-wrapper">
        {isLoading ? (
          <div className="page-content d-flex justify-content-center align-items-center">
            <div className="my-wrapper">
              <div className="spinner center">
                <div className="spinner-blade"></div>
                <div className="spinner-blade"></div>
                <div className="spinner-blade"></div>
                <div className="spinner-blade"></div>
                <div className="spinner-blade"></div>
                <div className="spinner-blade"></div>
                <div className="spinner-blade"></div>
                <div className="spinner-blade"></div>
                <div className="spinner-blade"></div>
                <div className="spinner-blade"></div>
                <div className="spinner-blade"></div>
                <div className="spinner-blade"></div>
              </div>
            </div>
          </div>
        )
          : (
            <div className="page-content">
              <div className="page-bar">
                <div className="page-title-breadcrumb">
                  <div className=" pull-left">
                    <div className="page-title my-0">List of Voices</div>
                  </div>
                </div>
                <div className="page-title-breadcrumb">
                  <div className=" pull-right">
                    <button
                      type="submit"
                      className="btn d-inline-block"
                      style={{ backgroundColor: "#1e2b38", color: "#FFF", border: "1px solid #1e2b38" }}
                      onClick={BackFunc}
                    >
                      {" "}
                      <i className="fa fa-arrow-left" aria-hidden="true"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="card">
                        <div className="card-head">
                          {/* <header>Voice List</header> */}
                          <header>
                            <div className="d-flex">
                              <div className="flex-grow-1">
                                <input
                                  type="text"
                                  value={filterText}
                                  placeholder="Search by Voice Name"
                                  onChange={(e) => setFilterText(e.target.value)}
                                  onKeyDown={handleKeyDown}
                                  onFocus={handleFocus}
                                  onBlur={handleBlur}
                                  autoFocus={true}
                                  style={{ borderTopRightRadius: "0px", borderBottomRightRadius: "0px" }}
                                  className="form-control" />
                              </div>

                              <button
                                type="button"
                                className="btn py-2 px-3 me-2 shadow-none"
                                onClick={FilterCases}
                                style={{ backgroundColor: "#1e2b38", color: "#FFF", border: "1px solid #1e2b38", borderTopLeftRadius: "0px", borderBottomLeftRadius: "0px" }}
                              >
                                <i className="fa fa-search"></i>
                              </button>

                              <button
                                type="button"
                                className="btn py-2 px-3 shadow-none"
                                onClick={onClearClicked}
                                style={{ backgroundColor: "#ffc63e", color: "#000", border: "1px solid #ffc63e", borderTopLeftRadius: "0px", borderBottomLeftRadius: "0px" }}
                              >
                                Clear
                              </button>
                            </div>

                          </header>
                        </div>
                        <div className="card-body ">
                          <div className="table-responsive">
                            <table className="table table-striped custom-table table-hover" style={{ tableLayout: "fixed" }}>
                              <thead>
                                <tr>
                                  <th>ID</th>
                                  <th width="25%">Voice Name</th>
                                  <th width="25%">Voice ID</th>
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {Record > 10
                                  ? paginatedPosts &&
                                  paginatedPosts.length > 0 &&
                                  paginatedPosts.map((item) => (
                                    <tr>
                                      <td className="text-left">{item.id}</td>
                                      <td>
                                        <Link
                                          to="/UpdateVoice"
                                          onClick={() => EditVoice(item.id)}
                                          className=""
                                        >
                                          <a href="#">{item.voice_Name}</a>
                                        </Link>
                                      </td>
                                      <td className="text-left">
                                        {item.voice_Id}
                                      </td>

                                      <td>
                                        <Link
                                          to="/UpdateVoice"
                                          onClick={() => EditVoice(item.id)}
                                          className="btn btn-xs py-2"
                                          style={{ backgroundColor: "#1e2b38", color: "#FFF", border: "1px solid #1e2b38" }}
                                        >
                                          <i className="fa fa-pencil"></i>
                                        </Link>
                                        <button
                                          className="btn btn-danger btn-xs py-2"
                                          onClick={() => {
                                            Swal.fire({
                                              title: "Are you sure?",
                                              text: "You won't be able to revert this!",
                                              icon: "warning",
                                              showCancelButton: true,
                                              confirmButtonColor: "#6777ef",
                                              cancelButtonColor: "#d33",
                                              confirmButtonText:
                                                "Yes, delete it!",
                                            }).then((result) => {
                                              if (result.isConfirmed) {
                                                deleteVoice(item.id);
                                              }
                                            });
                                          }}
                                        >
                                          <i className="fa fa-trash-o "></i>
                                        </button>
                                      </td>
                                    </tr>
                                  ))
                                  : VoiceList2 &&
                                  VoiceList2.length > 0 &&
                                  VoiceList2.map((item) => (
                                    <tr>
                                      <td className="text-left">{item.id}</td>
                                      <td>
                                        <Link
                                          to="/UpdateVoice"
                                          onClick={() => EditVoice(item.id)}
                                          className=""
                                        >
                                          <a href="#">{item.voice_Name}</a>
                                        </Link>
                                      </td>
                                      <td className="text-left">
                                        {item.voice_Id}
                                      </td>

                                      <td>
                                        <Link
                                          to="/UpdateVoice"
                                          onClick={() => EditVoice(item.id)}
                                          className="btn btn-xs py-2"
                                          style={{ backgroundColor: "#1e2b38", color: "#FFF", border: "1px solid #1e2b38" }}
                                        >
                                          <i className="fa fa-pencil"></i>
                                        </Link>
                                        <button
                                          className="btn btn-danger btn-xs py-2"
                                          onClick={() => {
                                            Swal.fire({
                                              title: "Are you sure?",
                                              text: "You won't be able to revert this!",
                                              icon: "warning",
                                              showCancelButton: true,
                                              confirmButtonColor: "#6777ef",
                                              cancelButtonColor: "#d33",
                                              confirmButtonText:
                                                "Yes, delete it!",
                                            }).then((result) => {
                                              if (result.isConfirmed) {
                                                deleteVoice(item.id);
                                              }
                                            });
                                          }}
                                        >
                                          <i className="fa fa-trash-o "></i>
                                        </button>
                                      </td>
                                    </tr>
                                  ))}
                              </tbody>
                            </table>
                          </div>
                          {Record > 10 ? (
                            <ReactPaginate
                              previousLabel={"Prev"}
                              nextLabel={"Next"}
                              breakLabel={"..."}
                              pageCount={pageCount}
                              marginPagesDisplayed={2}
                              pageRangeDisplayed={3}
                              onPageChange={handlePageClick}
                              containerClassName={
                                "pagination justify-content-center"
                              }
                              pageClassName={"page-item"}
                              pageLinkClassName={"page-link"}
                              activeClassName={"active"}
                              previousClassName={"page-item"}
                              nextClassName={"page-item"}
                              previousLinkClassName={"page-link"}
                              nextLinkClassName={"page-link"}
                            />
                          ) : (
                            <div></div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )
        }
      </div>
    </>
  );
}

export default VoiceList;
